import React from 'react';
import { IonIcon } from '@ionic/react';
import { logoGithub, logoLinkedin, mailOutline } from 'ionicons/icons';
import { track } from '../lib/track';

const links: { href: string; label: string; download?: boolean }[] = [
  { href: '/home', label: '0:home' },
  { href: '/experience', label: '1:experience' },
  { href: '/projects', label: '2:projects' },
  { href: '/skills', label: '3:skills' },
  { href: '/education', label: '4:education' }
];

const SiteNav: React.FC<{ current: string }> = ({ current }) => (
  <header className="site-nav">
    <div className="site-nav__inner">
      <a className="site-nav__mark" href="/home">
        mujahid@masood<span>:~$</span>
      </a>
      <nav className="site-nav__links">
        {links.map(link => (
          <a
            key={link.href}
            href={link.href}
            className={`site-nav__link${current === link.href ? ' site-nav__link--active' : ''}`}
            {...(link.download ? { download: 'Mujahid_Masood_Resume.pdf', target: '_blank', rel: 'noreferrer' } : {})}
          >
            {link.label}
          </a>
        ))}
      </nav>
      <a
        className="site-nav__cv"
        href="/Mujahid_Masood_Resume.pdf"
        download="Mujahid_Masood_Resume.pdf"
        target="_blank"
        rel="noreferrer"
        onClick={() => track('cv_download', { source: 'nav' })}
      >
        cv ⇩
      </a>
      <div className="site-nav__actions">
        <a className="site-nav__icon" href="https://github.com/mujahidmasood" target="_blank" rel="noreferrer" aria-label="GitHub">
          <IonIcon icon={logoGithub} />
        </a>
        <a className="site-nav__icon" href="https://www.linkedin.com/in/mujahidmasood/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
          <IonIcon icon={logoLinkedin} />
        </a>
        <a className="site-nav__icon" href="mailto:mujahid.mms@gmail.com" aria-label="Email">
          <IonIcon icon={mailOutline} />
        </a>
      </div>
    </div>
  </header>
);

export default SiteNav;
